import { Component, OnInit } from '@angular/core';

import { User } from '../../models/user';
import { Route, ActivatedRoute } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { UserService } from 'src/app/services/user.service';
import { ModalService } from 'src/app/services/modal.service';
import { ProductService } from 'src/app/services/product.service';
import { CompanyService } from 'src/app/services/company.service';

@Component({
    templateUrl: 'customer-view.component.html',
    styleUrls: ['./customer-view.component.scss']
})

export class CustomerViewComponent implements OnInit {
    currentUser: User;
    products: any[] = [];
    productId: any;
    labelId: any;
    customerId: any;
    currentProduct: any;
    currentLabel: any;
    currentCustomer: any;

    constructor(
        private userService: UserService,
        public modalService: ModalService,
        public productService: ProductService,
        public route: ActivatedRoute,
        public companyService: CompanyService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }

    ngOnInit() {
        this.customerId = this.route.snapshot.paramMap.get("id");
        this.loadCustomer(this.customerId);
    }

    deleteUser(_id: string) {
        this.userService.delete(_id).subscribe(() => { this.loadAllProducts() });
    }

    private loadAllProducts() {
        this.productService.getAll(this.currentUser).subscribe(products => { this.products = products; console.log(this.products); });

    }

    editProduct() {
        this.modalService.openEditProduct();
    }

    loadLabel(labelId: any) {
        this.productService.getOneLabel(labelId).subscribe(value => {
            console.log(value);
            this.currentLabel = value;
            this.productService.currentLabel = value;
        });
    }


    loadCustomer(customerId: any) {
        this.currentCustomer = null;
        this.companyService.currentCustomer = null;
        console.log('-------------getCustomer');
        this.companyService.getOneCustomer(customerId).subscribe(value => {
            console.log(value);
            this.currentCustomer = value;
            this.companyService.currentCustomer = value;
        });
    }

    removeCustomization(customization: any) {
        this.productService.removeCustomization(this.productService.currentProduct._id, customization).subscribe(value => {
            console.log(value);
        });
    }

    activateProduct() {
        this.productService.activateProduct(this.currentProduct._id).subscribe(value => {
            console.log(value);
        });
    }

    deactivateProduct() {
        this.productService.deactivateProduct(this.currentProduct._id).subscribe(value => {
            console.log(value);
        });
    }
}